import React, { useState } from 'react';
import {
    Box,
    VStack,
    HStack,
    Select,
    Text,
    Divider,
    FormControl,
    Button,
    useToast,
} from '@chakra-ui/react';
import CustomInput from '../../../../components/common/CustomInput'; // Adjust the path if necessary
import CustomLabel from '../../../../components/common/CustomLabel'; // Adjust the path if necessary
import { ACCOUNTS_URL } from '../../../../Globalapi/Globalapi';

function LeftFormSection({ colors }) {
    const [loading, setLoading] = useState(false);
    const toast = useToast();

    const [prefix, setPrefix] = useState('');
    const [name, setName] = useState('');
    const [ledgerGroup, setLedgerGroup] = useState('');
    const [address, setAddress] = useState('');
    const [place, setPlace] = useState('');
    const [mobile, setMobile] = useState('');
    const [taxId, setTaxId] = useState('');
    const [email, setEmail] = useState('');
    const [gpDays, setGpDays] = useState('');
    const [description, setDescription] = useState('');
    const [openingBalance, setOpeningBalance] = useState('');
    const [closingBalance, setClosingBalance] = useState('0');
    const [balanceTypeOpening, setBalanceTypeOpening] = useState('Dr');
    const [balanceTypeClosing, setBalanceTypeClosing] = useState('Dr');

    const validateForm = () => {
        let errors = {};
        if (!name) errors.name = "Name is required.";
        if (!ledgerGroup) errors.ledgerGroup = "Ledger Group is required.";
        if (!mobile) errors.mobile = "Mobile Number is required.";
        if (!email) errors.email = "Email is required.";
        // Add more validation as needed...
        return errors;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            toast({
                title: "Error!",
                description: Object.values(errors).join(' '),
                status: "error",
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        setLoading(true);

        const userid = sessionStorage.getItem('user_id');
        const cmpid = sessionStorage.getItem('cmp_id');

        const datatosubmit = {
            customer_name: name,
            ledger_group: ledgerGroup,
            led_discription: description,
            led_opbal: parseFloat(openingBalance),
            closing_bal: parseFloat(closingBalance),
            opbal_type: balanceTypeOpening === 'Dr' ? 1 : 2,
            user_id: userid,
            cmp_id: cmpid,
            cu_prifix: prefix,
            cu_address: address,
            cu_place: place,
            cu_moble: mobile,
            cu_tin: taxId,
            cu_email: email,
            cu_gpdays: gpDays || 0,
        };

        try {
            const response = await fetch(`${ACCOUNTS_URL}/party/party_create.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(datatosubmit),
            });

            const data = await response.json();

            if (data.success) {
                toast({
                    title: "Success!",
                    description: "Customer created successfully.",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                });
                resetForm();
            } else {
                throw new Error(data.message);
            }
        } catch (error) {
            toast({
                title: "Error!",
                description: error.message || "An error occurred while creating the customer.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        } finally {
            setLoading(false);
        }
    };

    const resetForm = () => {
        setPrefix('');
        setName('');
        setLedgerGroup('');
        setAddress('');
        setPlace('');
        setMobile('');
        setTaxId('');
        setEmail('');
        setGpDays('');
        setDescription('');
        setOpeningBalance('');
        setClosingBalance('0');
        setBalanceTypeOpening('Dr');
        setBalanceTypeClosing('Dr');
    };

    return (
        <Box
            as="form"
            onSubmit={handleSubmit}
            bg="white"
            borderWidth="1px"
            p={6}
            style={{ borderRadius: '20px' }}
            w="100%"
            minH="750px"
        >
            <Text fontSize="2xl"  mb={4}>
                Customers
            </Text>
            <Divider mb={4} />

            <VStack spacing={4} align="stretch">
                <HStack
                    spacing={4}
                    w="100%"
                    flexDirection={{ base: 'column', md: 'row' }}
                >
                    <FormControl w={{ base: '100%', md: '400px' }} isRequired>
                        <CustomLabel labelText="Prefix" />
                        <Select
                            name="prefix"
                            placeholder="Select Prefix"
                            value={prefix}
                            onChange={(e) => setPrefix(e.target.value)}
                        >
                            <option value="1">Mr</option>
                            <option value="2">Ms</option>
                            <option value="3">Mrs</option>
                        </Select>
                    </FormControl>

                    <FormControl isRequired w={{ base: '100%' }}>
                        <CustomLabel labelText="Name" />
                        <CustomInput
                            placeholder="Enter Name"
                            name="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </FormControl>

                    <FormControl isRequired w={{ base: '100%' }}>
                        <CustomLabel labelText="Ledger Group" />
                        <Select
                            name="ledgerGroup"
                            placeholder="Select Group"
                            value={ledgerGroup}
                            onChange={(e) => setLedgerGroup(e.target.value)}
                        >
                            <option value="31">Sundry Debtors</option>
                        </Select>
                    </FormControl>
                </HStack>

                <HStack
                    spacing={4}
                    w="100%"
                    flexDirection={{ base: 'column', md: 'row' }}
                >
                    <FormControl isRequired w={{ base: '100%' }}>
                        <CustomLabel labelText="Mobile No" />
                        <CustomInput
                            placeholder="Enter Mobile Number"
                            name="mobile"
                            value={mobile}
                            onChange={(e) => setMobile(e.target.value)}
                        />
                    </FormControl>

                    <FormControl isRequired w={{ base: '100%' }}>
                        <CustomLabel labelText="Email" />
                        <CustomInput
                            placeholder="Enter Email"
                            name="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </FormControl>
                </HStack>

                <HStack
                    spacing={4}
                    w="100%"
                    flexDirection={{ base: 'column', md: 'row' }}
                >
                    <FormControl w={{ base: '100%' }}>
                        <CustomLabel labelText="Address" />
                        <CustomInput
                            placeholder="Enter Address"
                            name="address"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                        />
                    </FormControl>

                    <FormControl w={{ base: '100%' }}>
                        <CustomLabel labelText="Place" />
                        <CustomInput
                            placeholder="Enter Place"
                            name="place"
                            value={place}
                            onChange={(e) => setPlace(e.target.value)}
                        />
                    </FormControl>
                </HStack>

                <HStack
                    spacing={4}
                    w="100%"
                    flexDirection={{ base: 'column', md: 'row' }}
                >
                    <FormControl w={{ base: '100%' }}>
                        <CustomLabel labelText="Tax ID" />
                        <CustomInput
                            placeholder="Enter Tax ID"
                            name="taxId"
                            value={taxId}
                            onChange={(e) => setTaxId(e.target.value)}
                        />
                    </FormControl>

                    <FormControl w={{ base: '100%' }}>
                        <CustomLabel labelText="GP Days" />
                        <CustomInput
                            placeholder="Enter GP Days"
                            name="gpDays"
                            type="number"
                            value={gpDays}
                            onChange={(e) => setGpDays(e.target.value)}
                        />
                    </FormControl>
                </HStack>

                <FormControl isRequired>
                    <CustomLabel labelText="Description" />
                    <CustomInput
                        placeholder="Enter Description"
                        name="description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </FormControl>

                <HStack
                    spacing={4}
                    w="100%"
                    flexDirection={{ base: 'column', md: 'row' }}
                >
                    <FormControl w="100%">
                        <HStack
                            spacing={4}
                            w="100%"
                            flexDirection={{ base: 'column', md: 'row' }}
                            alignItems="flex-start"
                        >
                            {/* Opening Balance */}
                            <FormControl w={{ base: '100%', md: '40%' }}>
                                <CustomLabel labelText="Opening Balance" />
                                <CustomInput
                                    placeholder="0.00"
                                    name="openingBalance"
                                    value={openingBalance}
                                    onChange={(e) => setOpeningBalance(e.target.value)}
                                    textAlign="right"
                                />
                            </FormControl>

                            {/* Balance Type Opening */}
                            <FormControl w={{ base: '100%', md: '20%' }} mt={{ base: 2, md: 8 }}>
                                <Select
                                    name="balanceTypeOpening"
                                    value={balanceTypeOpening}
                                    onChange={(e) => setBalanceTypeOpening(e.target.value)}
                                >
                                    <option value="1">Dr</option>
                                    <option value="2">Cr</option>
                                </Select>
                            </FormControl>

                            {/* Closing Balance */}
                            <FormControl w={{ base: '100%', md: '40%' }}>
                                <CustomLabel labelText="Closing Balance" />
                                <CustomInput
                                    placeholder="0.00"
                                    name="closingBalance"
                                    value={closingBalance}
                                    onChange={(e) => setClosingBalance(e.target.value)}
                                    textAlign="right"
                                    isDisabled={true}
                                />
                            </FormControl>

                            {/* Balance Type Closing */}
                            <FormControl w={{ base: '100%', md: '20%' }} mt={{ base: 2, md: 8 }}>
                                <Select
                                    name="balanceTypeClosing"
                                    value={balanceTypeClosing}
                                    onChange={(e) => setBalanceTypeClosing(e.target.value)}
                                >
                                    <option value="1">Dr</option>
                                    <option value="2">Cr</option>
                                </Select>
                            </FormControl>
                        </HStack>
                    </FormControl>
                </HStack>


            </VStack>

            <Button
                mt={6}
                bg="#ff8f00"
                color='white'
                type="submit"
                isLoading={loading}
                isDisabled={loading} // Disable form inputs while loading
            >
                Create Customer
            </Button>
        </Box>
    );
}

export default LeftFormSection;
